import client from '../client'

export const getMakesKey = `${process.env.NEXT_PUBLIC_SEARCH_DOMAIN}/api/Makes/GetMakes`

export async function getMakes() {
  return client(getMakesKey)
}
